import { render, staticRenderFns } from "./configurationSettings.vue?vue&type=template&id=d9bf7cf4"
import script from "./configurationSettings.vue?vue&type=script&lang=ts"
export * from "./configurationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports